import JoyLogo from "../../../assests/Images/TemplateElement/JoyPinkLogo.png";
import { DATE } from "../../../shared/constants.js";
import ImageCardTemplate from "./ImageCardTemplate";

function ImageTemplateBlue({ heading, caption, date, media, journalId,pageRefresh,ref,menuShow }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <ImageCardTemplate
        journalId={journalId}
        imgSrc={media}
        text={caption || heading || ""}
        date={date || DATE.JOURNAL_FORMAT}
        borderColor="#ff9fcf" // Custom green border
        backgroundColor="#005cff" // Custom blue background
        imageBottomRight={JoyLogo}
        imageBottomRightStyle={{
          width: { xs: 14, sm: 22, md: 22 },
          height: { xs: 14, sm: 22, md: 22 },
        }}
        textColor="#ffffff"
        pageRefreshCallback={pageRefresh}
        ref={ref}
        menuShow={menuShow}
      />
    </div>
  );
}

export default ImageTemplateBlue;
